var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"a-icon-button",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('svg-icon',{attrs:{"original":"","name":("icons/" + _vm.icon)}}),_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }